// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__366a-","rootSmall":"AddTileButton_rootSmall__3VvYq"};